import React, { useState } from "react";
import { Table, Input, Button, Space, Divider } from "antd";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const DynamicTable = () => {
  const [tables, setTables] = useState([
    {
      name: "",
      headers: ["Min", "Max"],
      rows: [{ Min: "", Max: "" }],
      newHeader: "",
    },
  ]);

  const addTable = () => {
    setTables([
      ...tables,
      {
        name: "",
        headers: ["Min", "Max"],
        rows: [{ Min: "", Max: "" }],
        newHeader: "",
      },
    ]);
  };
  const deleteTable = (tableIndex) => {
    setTables(tables.filter((_, index) => index !== tableIndex));
  };

  const addHeader = (tableIndex) => {
    const newTables = [...tables];
    if (newTables[tableIndex].newHeader) {
      newTables[tableIndex].headers.push(newTables[tableIndex].newHeader);
      newTables[tableIndex].newHeader = "";
      setTables(newTables);
    }
  };

  const deleteHeader = (tableIndex, headerIndex) => {
    const newTables = [...tables];
    newTables[tableIndex].headers.splice(headerIndex, 1);
    newTables[tableIndex].rows.forEach(
      (row) => delete row[newTables[tableIndex].headers[headerIndex]]
    );
    setTables(newTables);
  };

  const addRow = (tableIndex) => {
    const newTables = [...tables];
    const newRow = {};
    newTables[tableIndex].headers.forEach((header) => (newRow[header] = ""));
    newTables[tableIndex].rows.push(newRow);
    setTables(newTables);
  };
  //   const deleteRow = (tableIndex, rowIndex) => {
  //     const newTables = [...tables];
  //     newTables[tableIndex].rows.splice(rowIndex, 1);
  //     setTables(newTables);
  //   };

  const handleInputChange = (tableIndex, rowIndex, header, value) => {
    const newTables = [...tables];
    newTables[tableIndex].rows[rowIndex][header] = value;
    setTables(newTables);
  };

  const handleTableNameChange = (tableIndex, value) => {
    const newTables = [...tables];
    newTables[tableIndex].name = value;
    setTables(newTables);
  };

  const handleNewHeaderChange = (tableIndex, value) => {
    const newTables = [...tables];
    newTables[tableIndex].newHeader = value;
    setTables(newTables);
  };

  console.log(tables, "tabless");

  return (
    <div className="master-main-container p-2">
      <div
        style={{
          padding: "10px",
          maxWidth: "900px",
          minWidth: "200px",
          margin: "auto",
          background: "#fff",
        }}
      >
        {tables.map((table, tableIndex) => (
          <>
            <div key={tableIndex} style={{ marginBottom: "20px" }}>
              <div className="space-between">
                <Input
                  placeholder="Enter Service Type"
                  value={table.name}
                  onChange={(e) =>
                    handleTableNameChange(tableIndex, e.target.value)
                  }
                  style={{ marginBottom: "10px", width: "200px" }}
                />
                <Button
                  type="danger"
                  onClick={() => deleteTable(tableIndex)}
                  icon={<DeleteOutlined />}
                />
              </div>

              <Table
                bordered
                style={{ overflow: "scroll" }}
                dataSource={table.rows.map((row, rowIndex) => ({
                  ...row,
                  key: rowIndex,
                }))}
                columns={table.headers
                  .map((header, headerIndex) => ({
                    title: (
                      <Space>
                        {header}
                        <Button
                          type="text"
                          icon={<DeleteOutlined />}
                          onClick={() => deleteHeader(tableIndex, headerIndex)}
                        />
                      </Space>
                    ),
                    dataIndex: header,
                    key: header,
                    render: (_, record, rowIndex) => (
                      <Input
                        value={record[header]}
                        //style={{ width: "150px" }}
                        onChange={(e) =>
                          handleInputChange(
                            tableIndex,
                            rowIndex,
                            header,
                            e.target.value
                          )
                        }
                      />
                    ),
                  }))
                  .concat({
                    title: (
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <Input
                          placeholder="New Zone"
                          value={table.newHeader}
                          onChange={(e) =>
                            handleNewHeaderChange(tableIndex, e.target.value)
                          }
                          style={{ width: "150px", marginRight: "8px" }}
                        />
                        <Button
                          type="dashed"
                          onClick={() => addHeader(tableIndex)}
                          icon={<PlusOutlined />}
                        />
                      </div>
                    ),
                    key: "addHeader",
                  })}
                pagination={false}
              />
              <Space style={{ marginTop: "10px" }}>
                <Button
                  type="dashed"
                  onClick={() => addRow(tableIndex)}
                  icon={<PlusOutlined />}
                >
                  Add Slab
                </Button>
              </Space>
              {/* {table.rows.map((_, rowIndex) => (
                <Button
                  key={rowIndex}
                  type="text"
                  icon={<DeleteOutlined />}
                  onClick={() => deleteRow(tableIndex, rowIndex)}
                />
              ))} */}
            </div>
            <Divider />
          </>
        ))}

        <div className="center">
          <Button
            type="primary"
            onClick={addTable}
            icon={<PlusOutlined />}
            style={{ marginTop: "10px" }}
            className="save-btn"
          >
            Add Rate Matrix Type
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DynamicTable;
